import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientSaveFullySignedClientServiceAgreementFileMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

import { parseLegalClient } from './helpers';

export const useLegalClientSaveSigningContract = () => {
  const [handle, { loading, error: apolloError }] =
    useLegalClientSaveFullySignedClientServiceAgreementFileMutation();

  const error = useError(apolloError);

  return {
    loading,
    error,
    signingContract: useCallback(
      async (clientId: string, fileId: string) => {
        const res = await handle({
          variables: {
            id: clientId,
            input: { fullySignedClientServiceAgreementFileId: fileId },
          },
        });

        return res.data?.legalClient
          ? parseLegalClient(res.data?.legalClient)
          : undefined;
      },
      [handle]
    ),
  };
};
